/* eslint-disable no-array-reduce/no-reduce */
/* eslint-disable @typescript-eslint/no-misused-promises */
/* eslint-disable id-length */
/* eslint-disable @typescript-eslint/no-floating-promises */

import { ApplyOrderRequestNeedle, NeedleAnalyticI } from './types';

export default class NeedleAnalytic implements NeedleAnalyticI {
  private scriptLoaded = false;

  private getNeedleParam() {
    return typeof window !== 'undefined' ? window.needleParam : undefined;
  }

  public async removeNeedle(): Promise<boolean> {
    return new Promise((_, reject) => {
      try {
        const Needle = window.Needle || undefined;

        if (!Needle) return;

        const currentScript = document.querySelector('script[src*="pyramydair.needle.com/pload"]');
        if (currentScript) currentScript.remove();

        if (Needle.removeNeedlePoint) {
          Needle.removeNeedlePoint('needle-script-load');
        }
        this.scriptLoaded = false;
      } catch (error) {
        console.error('Can`t provide Needle script', error);
        reject(false);
      }
    });
  }

  public async reloadNeedle(): Promise<boolean> {
    return new Promise((resolve, reject) => {
      try {
        const Needle = window.Needle || undefined;

        if (!Needle || this.scriptLoaded) return;

        const needleJSScriptDoc = document.createElement('script');
        needleJSScriptDoc.id = 'needle-script-load';
        needleJSScriptDoc.type = 'text/javascript';
        needleJSScriptDoc.defer = true;
        needleJSScriptDoc.src = '//pyramydair.needle.com/needle_service.js?ver=1';
        needleJSScriptDoc.onload = () => {
          this.scriptLoaded = true;
          resolve(true);
        };
        if (document?.body?.lastChild?.nextSibling) {
          document.body.insertBefore(needleJSScriptDoc, document.body.lastChild.nextSibling);
        }
        this.scriptLoaded = true;

        Needle.PageLoad();
      } catch (error) {
        console.error('Can`t provide Needle script', error);
        reject(false);
      }
    });
  }

  public async loadNeedleScript(): Promise<boolean> {
    return new Promise((resolve, reject) => {
      if (this.scriptLoaded) {
        return resolve(true);
      }

      try {
        const Needle = window.Needle || undefined;

        if (!Needle) return;

        const needleJSScriptDoc = document.createElement('script');
        needleJSScriptDoc.id = 'needle-script-load';
        needleJSScriptDoc.type = 'text/javascript';
        needleJSScriptDoc.defer = true;
        needleJSScriptDoc.src = '//pyramydair.needle.com/needle_service.js?ver=1';
        needleJSScriptDoc.onload = () => {
          this.scriptLoaded = true;
          resolve(true);
        };
        if (document?.body?.firstChild?.nextSibling) {
          document.body.insertBefore(needleJSScriptDoc, document.body.firstChild.nextSibling);
        }
      } catch (error) {
        console.error('Can`t provide Needle script', error);
        reject(false);
      }
    });
  }

  public async applyOrder(request: ApplyOrderRequestNeedle) {
    const needleParam = this.getNeedleParam();

    if (needleParam) {
      const { suborders } = request;

      needleParam.events = 'purchase';
      needleParam.orderItems = ``;

      const needleParamJSScriptDoc = document.createElement('script');
      needleParamJSScriptDoc.type = 'text/javascript';
      needleParamJSScriptDoc.text = `
            var needleParam = needleParam || {};
            needleParam.events = '${needleParam.events}';
          `;

      suborders.forEach(async (suborder: any) => {
        needleParam.orderId = suborder?.masterOrderId
          ? suborder?.masterOrderId.toString()
          : suborder?.orderId.toString();
        needleParam.orderItems = suborder.products.reduce(
          (acc: any, product: any) => `${acc}${product.sku}:${product.quantity}:${product.price},`,
          needleParam.orderItems,
        );
        needleParamJSScriptDoc.text = `${needleParamJSScriptDoc.text} `;
      });

      needleParamJSScriptDoc.text = `${needleParamJSScriptDoc.text}
        needleParam.orderId = '${needleParam.orderId}';
        needleParam.orderItems = '${needleParam.orderItems.replace(/,\s*$/, '')}';`;

      document.body.insertBefore(needleParamJSScriptDoc, document.body.firstChild);
    } else {
      console.warn('No Needle was provided');
    }
  }

  public async categoryNeedle(category: string) {
    const needleParam = this.getNeedleParam();
    if (needleParam) {
      const needleParamJSScriptDoc = document.createElement('script');
      needleParamJSScriptDoc.type = 'text/javascript';
      needleParamJSScriptDoc.text = `
        var needleParam = needleParam || {};
        needleParam.skillGroup = '${category}';
      `;
      document.body.insertBefore(needleParamJSScriptDoc, document.body.firstChild);
    } else {
      console.warn('No Needle was provided');
    }
  }
}
